import type { LayoutStore } from './layout.type'

export const selectInviteProjectDialogOpen = (state: LayoutStore) => state.inviteProjectOpen

export const selectInviteWorkspaceDialogOpen = (state: LayoutStore) => state.inviteWorkspaceOpen

export const selectLayoutLoadingState = (state: LayoutStore) => ({
  isLoading: state.isLoading,
  showLoaderOnSettings: state.showLoaderOnSettings,
})

export const selectLoaderOverlayState = (state: LayoutStore) => ({
  isLoading: state.isLoading,
  loaderMessage: state.loaderMessage,
  showLoaderOnSettings: state.showLoaderOnSettings,
})

export const selectLayoutUiState = (state: LayoutStore) => ({
  createProjectDialogOpen: state.createProjectDialogOpen,
  feedbackPopoverOpen: state.feedbackPopoverOpen,
  inviteProjectOpen: state.inviteProjectOpen,
  inviteWorkspaceOpen: state.inviteWorkspaceOpen,
  mobileMenuOpen: state.mobileMenuOpen,
  sidebarCollapsed: state.sidebarCollapsed,
})

export const selectGlobalLoading = (state: LayoutStore) => state.isLoading

export const selectLayoutShellState = (state: LayoutStore) => ({
  isLoading: state.isLoading,
  sidebarCollapsed: state.sidebarCollapsed,
  openCreateProjectDialog: state.openCreateProjectDialog,
  closeMobileMenu: state.closeMobileMenu,
})

export const selectLayoutSidebarState = (state: LayoutStore) => ({
  sidebarCollapsed: state.sidebarCollapsed,
  toggleSidebar: state.toggleSidebar,
})
